import { Location, RadiusLocation, SuburbLocation } from '../types';

export function isRadiusLocation(value: Location): value is RadiusLocation {
  return value.type === 'radius';
}

export function isSuburbLocation(value: Location): value is SuburbLocation {
  return value.type === 'suburb';
}
